import script from "./HeaderPortafolio.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderPortafolio.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderPortafolio.vue?vue&type=style&index=0&id=e98e5fa4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e98e5fa4"]])

export default __exports__